module.exports = __webpack_public_path__ + "img/users-solid1.da08cd4b.svg";